document.addEventListener("DOMContentLoaded", function () {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let hasPrivacyProduct = cart.items.some(item => item.url.includes('baby-first-aid-course'));
            if (hasPrivacyProduct) {
                document.body.setAttribute('data-privacy-product', 'true');
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
});
